import React from 'react';
import { Button } from 'native-base';

export interface BasicsTagProps {
  readonly text: string;
  readonly icon?: JSX.Element | Array<JSX.Element>;
}

export function BasicsTag({ text, icon = undefined }: BasicsTagProps) {
  return (
    <Button
      startIcon={icon}
      px={4}
      py={1.5}
      mb={2}
      backgroundColor={`rgba(0,0,0,0.15)`}
      borderColor={'surface.300'}
      borderWidth={2}
      disabled
      rounded={'full'}
      _text={{
        textAlign: 'center',
        color: 'surface.500',
        fontSize: 13,
        fontFamily: 'body',
        fontWeight: 600,
        fontStyle: 'normal',
      }}
    >
      {text}
    </Button>
  );
}

export default React.memo(BasicsTag);
